import React from 'react';
import { ButtonComp } from '../../../../atoms/Buttons';
import ImageComponent from '../../../../atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useSelector } from 'react-redux';
const { Error } = IMAGE_PATH;

const SearchErrorsComp = props => {
  const { show, errorObj, isInProgress } = props;
  const { firstBtnCTA, secondBtnCTA, firstBtnText, secondBtnText, errMsg, firstBtnClassName = '' } = errorObj;
  const isApiLoading = state => {
    return (
      //Loader Action
      state.LoaderReducer?.isLoading
    );
  };
  const isLoading = useSelector(state => isApiLoading(state) ?? isInProgress);

  return (
    <React.Fragment>
      {!isLoading &&
        (show ? (
          <div className='err-container'>
            <div data-testid='search-error-container' className='alert-location-popup'>
              <ImageComponent srcFile={Error} className='location-alert-icon' />
              <>
                <div className='location-error-message'>{errMsg}</div>
                <div className='location-error-button-section'>
                  {firstBtnCTA && (
                    <ButtonComp
                      data-testid='first-btn-click'
                      className={`button whiteButton blackBorder location-warning-button ${firstBtnClassName}`}
                      onClickHandler={e => firstBtnCTA(e)}
                    >
                      {firstBtnText}
                    </ButtonComp>
                  )}
                  {secondBtnCTA && (
                    <ButtonComp
                      data-testid='second-btn-click'
                      className='button whiteButton blackBorder location-warning-button ml'
                      onClickHandler={e => secondBtnCTA(e)}
                    >
                      {secondBtnText}
                    </ButtonComp>
                  )}
                </div>
              </>
            </div>
          </div>
        ) : null)}
    </React.Fragment>
  );
};

const SearchErrors = React.memo(SearchErrorsComp);
export default SearchErrors;
